import { AUTOMATION_STEPS } from 'pages/AutomationEngine/steps';
import { TFunction } from 'react-i18next';

import { ContextValue, SourceVariableType, VariableNameAndType } from './types';
import { AutomationVariableDataType } from 'pages/AutomationEngine/types';

type VariableDefinitionType = any;

export const createWizardState = (step: any, defaultValue: ContextValue) => {
  if (!step) {
    return {
      ...defaultValue,
      type: AUTOMATION_STEPS.initialize_variable.type,
      id: `new.${AUTOMATION_STEPS.initialize_variable.type}.${Date.now()}`,
    };
  }
  const sourcesMask = (step?.details?.sources || []).map(
    ({ sourceType }: SourceVariableType) => sourceType
  );

  switch (step.type) {
    default:
      return {
        ...defaultValue,
        ...step.details,
        sourcesMask,
        id: step.id,
      };
  }
};

export const createPayload = (values: any, step: any) => {
  return {
    ...step,
    type: values.type,
    details: { ...values },
  };
};

export const ACTIONS_ON_FAILURE = {
  NOTIFY_CONTINUE: 'notify_continue',
  NOTIFY_PAUSE: 'notify_pause',
  SILENT_CONTINUE: 'silent_continue',
};

export const getActionOnFailureOptions = (t: TFunction) => [
  {
    label: t('Continue and Notify on Failure'),
    value: ACTIONS_ON_FAILURE.NOTIFY_CONTINUE,
  },
  {
    label: t('Pause and Notify on Failure'),
    value: ACTIONS_ON_FAILURE.NOTIFY_PAUSE,
  },
  {
    label: t('Continue on Failure and Do Not Notify'),
    value: ACTIONS_ON_FAILURE.SILENT_CONTINUE,
  },
];

export const getDefaultActionOnFailure = (stepType: VariableDefinitionType) => {
  return ACTIONS_ON_FAILURE.NOTIFY_PAUSE;
};

export const getActionOnFailureNote = (stepType: any, t: TFunction) => {
  switch (stepType) {
    case AUTOMATION_STEPS.start_automation.type:
    case AUTOMATION_STEPS.modify_automation.type:
    case AUTOMATION_STEPS.change_tags.type:
    case AUTOMATION_STEPS.modify_related_entities.type:
      return t(
        'This step has multiple components, so it will only fail if ALL components fail.'
      );
    case AUTOMATION_STEPS.http_request.type:
      return t(
        'Anything other than 200- and 300-class responses will be considered an error.'
      );
    case AUTOMATION_STEPS.send_email.type:
      return t(
        'Emails will be marked as successful if there is an existing email that is not on the suppression list.'
      );
    case AUTOMATION_STEPS.create_related_entity.type:
      return t(
        'This will be marked as a failure if either the creation or agentic workflow execution fails, but will ignore field update failures.'
      );
    case AUTOMATION_STEPS.send_related_contact_email.type:
      return t(
        'Emails will be marked as successful if there is at least one existing email that is not on the suppression list.'
      );
    default:
      return null;
  }
};

export const isVariableInitialization = (stepType: string, type: string = '') =>
  stepType === 'initialize_variable' || type === 'initialize_variable';

export const isUUIDcompatible = (
  type: AutomationVariableDataType | undefined
) => (type ? ['string', 'uuid'].includes(type) : false);

export const isVariableEntityType = (variable: VariableNameAndType) =>
  variable?.dataType === 'entity';
